import {
    FETCH_SEARCH_SUGGESTIONS,
    CLEAR_SEARCH_SUGGESTIONS,
    FETCH_SEARCH_SUGGESTIONS_SUCCESS,
    FETCH_SEARCH_SUGGESTIONS_FAILED,
    SearchSuggestionBucket,
    SearchSuggestionActionTypes,
    SearchSuggestionState,
    SuggestionResponse,
    FETCH_SEARCH_REDIRECT,
    FETCH_SEARCH_REDIRECT_FAIL,
    FETCH_SEARCH_REDIRECT_SUCCESS,
    SET_QUERY,
} from './types';

const initialState: SearchSuggestionState = {
    isFetching: false,
    didInvalidate: false,
    query: '',
    suggestion: {
        categories: [],
        brands: [],
        products: [],
        staticPages: [],
    },
    searchRedirect: {
        categories: [],
        brands: [],
        products: [],
        staticPages: [],
    },
};
export const mapApiResponseToSearchData = (suggestionResponse: SuggestionResponse): SearchSuggestionBucket => ({
    title: suggestionResponse.title || '',
    urlKey: suggestionResponse.url_key || '',
    highlight: suggestionResponse.highlight || '',
    productCount: suggestionResponse.productCount || 0,
});

export default function searchSuggestionReducer(
    state = initialState,
    action: SearchSuggestionActionTypes
): SearchSuggestionState {
    switch (action.type) {
        case SET_QUERY:
            return {
                ...state,
                query: action.payload.query,
            };
        case FETCH_SEARCH_SUGGESTIONS:
        case FETCH_SEARCH_REDIRECT:
            return {
                ...state,
                isFetching: true,
            };
        case FETCH_SEARCH_SUGGESTIONS_SUCCESS: {
            const { data = {} } = action.payload;
            const { Categories = [] } = data;
            const { Brands = [] } = data;
            const { Products = [] } = data;
            const { StaticPages = [] } = data;
            return {
                ...state,
                isFetching: false,
                didInvalidate: false,
                suggestion: {
                    categories: Categories.map(mapApiResponseToSearchData),
                    brands: Brands.map(mapApiResponseToSearchData),
                    products: Products.map(mapApiResponseToSearchData),
                    staticPages: StaticPages.map(mapApiResponseToSearchData),
                },
            };
        }

        case FETCH_SEARCH_REDIRECT_SUCCESS: {
            const { data = {} } = action.payload;
            const { Categories = [] } = data;
            const { Brands = [] } = data;
            const { Products = [] } = data;
            const { StaticPages = [] } = data;

            return {
                ...state,
                isFetching: false,
                didInvalidate: false,
                searchRedirect: {
                    categories: Categories.map(mapApiResponseToSearchData),
                    brands: Brands.map(mapApiResponseToSearchData),
                    products: Products.map(mapApiResponseToSearchData),
                    staticPages: StaticPages.map(mapApiResponseToSearchData),
                },
            };
        }

        case FETCH_SEARCH_SUGGESTIONS_FAILED:
        case FETCH_SEARCH_REDIRECT_FAIL: {
            return {
                ...state,
                isFetching: false,
                didInvalidate: true,
                error: action.payload,
            };
        }
        case CLEAR_SEARCH_SUGGESTIONS: {
            const { exemptQuery } = action.payload;
            return exemptQuery ? { ...initialState, query: state.query } : initialState;
        }
        default: {
            return state;
        }
    }
}
